import React from 'react';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import IServerOutput, {ServerStatus} from 'features/server/model/Server/IServer';
import {getFormattedDate} from 'shared/lib/datetime';
import {isTranslate} from 'shared/lib/lang';
import {getServerStatusLabel} from 'features/server/lib/serverStatusHelper';
import {formatBytesToGb} from 'features/server/lib/serverMetricsHelper';

import styles from './ServerStatistics.module.scss';

interface IServerStatisticsProps {
    server: IServerOutput,
}

const STATUS_ITEM_CLASS: Partial<Record<ServerStatus, string>> = {
    online: 'itemOnline',
    offline: 'itemOffline',
    suspended: 'itemSuspended',
};

const ServerStatistics: React.FC<IServerStatisticsProps> = ({server}) => {
    const dateFormat = !isTranslate() ? 'DD.MM.YYYY HH:mm' : 'YYYY-MM-DD HH:mm';

    const items = [
        {label: t`Хост`, value: server.hostname ?? t`нет данных`},
        {label: t`ОС`, value: server.os ?? '—'},
        {label: t`Версия агента`, value: server.agent_version ?? '—'},
        {label: t`Ядра CPU`, value: server.cpu_cores ?? '—'},
        {label: t`RAM`, value: formatBytesToGb(server.mem_total)},
        {label: t`SWAP`, value: formatBytesToGb(server.swap_total)},
        {label: t`Хранение истории`, value: t`${server.retention_days} дн.`},
        {label: t`Токен обновлён`, value: getFormattedDate(server.token_updated_at, {format: dateFormat})},
        {label: t`Создан`, value: getFormattedDate(server.created_at, {format: dateFormat})},
    ];

    return (
        <div className={styles.section}>
            <div className={styles.grid}>
                <div className={cn(styles.item, styles[STATUS_ITEM_CLASS[server.status] ?? ''])}>
                    <span className={styles.label}>{t`Статус`}</span>
                    <span className={styles.value}>{getServerStatusLabel(server.status)}</span>
                </div>
                {items.map((item) => (
                    <div key={item.label} className={styles.item}>
                        <span className={styles.label}>{item.label}</span>
                        <span className={styles.value}>{item.value}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ServerStatistics;
